<div
  #widget
  class="header-container"
  data-cy="header-widget"
  [ngClass]="{ smallScreen: isSmallScreen, focus: contextMenuOpened }"
  (click)="focusWidget(selectedIndex)"
>
  <u-icon *ngIf="movedWidget" class="dragging-icon" [model]="{ type: 'font', value: 'icon-dragging-ind' }" [styles]="{ fontSize: '12px' }">
  </u-icon>
  <div class="header-text" [style]="{ 'justify-content': settings?.alignTo }">
    <span
      (dblclick)="editMode = true"
      class="header-input"
      [style]="{ 'text-align': settings?.alignTo }"
      [ngClass]="{ 'fixed-margin': settings?.alignTo === 'center' || !movedWidget }"
      *ngIf="!editMode; else input"
      [pTooltip]="settings?.title?.length > MAX_LENGTH_HEADER ? settings?.title : null"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
      >{{ settings?.title }}</span
    >
    <ng-template #input>
      <input-title
        class="header-input"
        [text]="settings?.title"
        [ngClass]="{ 'align-center': settings?.alignTo === 'center' }"
        [inputPlaceholder]="settings?.title"
        [defaultInputModel]="'Untitled'"
        [inputModel]="settings?.title"
        [fontSize]="'regular'"
        (onBlurUInput)="renameHeader()"
        (outsideClick)="renameHeader()"
        (onChange)="onChangeName($event)"
      >
      </input-title>
    </ng-template>
  </div>
  <square-button
    *ngIf="canEdit"
    [active]="contextMenuOpened"
    class="square-button"
    (click)="$event.stopPropagation(); openContextMenu($event)"
    (auxclick)="$event.stopPropagation(); openContextMenu($event)"
    (contextmenu)="$event.stopPropagation(); openContextMenu($event)"
    #actions
    >•••
  </square-button>
</div>
